var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupportDesk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.375 6C21.9963 6 22.5 6.50368 22.5 7.125C22.5 7.74632 21.9963 8.25 21.375 8.25H19.128V10.1704C26.7008 10.735 31.5 16.9711 31.5 24.375C31.5 24.9963 30.9963 25.5 30.375 25.5H19.125V27.75H30.375C30.9963 27.75 31.5 28.2537 31.5 28.875C31.5 29.4963 30.9963 30 30.375 30H5.625C5.00368 30 4.5 29.4963 4.5 28.875C4.5 28.2537 5.00368 27.75 5.625 27.75H16.875V25.5H5.625C5.00368 25.5 4.5 24.9963 4.5 24.375C4.5 16.9692 9.30177 10.7323 16.878 10.1704V8.25H14.625C14.0037 8.25 13.5 7.74632 13.5 7.125C13.5 6.50368 14.0037 6 14.625 6H21.375Z",
    fill: "#171717",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportDesk);
export default __webpack_public_path__ + "static/media/support-desk.138336686227f7e5d8e871c2db7f6a14.svg";
export { ForwardRef as ReactComponent };